const loadVideoModals = () => {
    const videoModalButtons = document.querySelectorAll('button[data-video-id]')

    for (let i = 0; i < videoModalButtons.length; i++) {
        videoModalButtons[i].addEventListener('click', event => {
            const videoId = event.target.dataset.videoId
            const modal = document.getElementById(videoId)

            document.body.classList.add('modal-visible')
            modal.classList.add('visible')

            const modalClose = modal.querySelector('.close-modal')
            modalClose.addEventListener('click', () => {
                document.body.classList.remove('modal-visible')
                modal.classList.remove('visible')
            })
        })
    }
}

export default loadVideoModals



// WEBPACK FOOTER //
// ./js/videoModals.js